import React from 'react';
import Icon from '../../../components/AppIcon';

const TimeSlotSelector = ({ slots, selectedSlot, onSelect }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
      {slots?.map((slot) => (
        <button
          key={slot?.value}
          onClick={() => onSelect(slot?.value)}
          disabled={!slot?.available}
          className={`p-3 rounded-lg border-2 transition-all ${
            !slot?.available
              ? 'border-border bg-muted opacity-50 cursor-not-allowed'
              : selectedSlot === slot?.value
              ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 bg-card'
          }`}
        >
          <div className="flex flex-col items-center gap-2">
            <Icon
              name="Clock"
              size={18}
              color={
                selectedSlot === slot?.value
                  ? 'var(--color-primary)'
                  : 'var(--color-muted-foreground)'
              }
            />
            <div className="text-sm font-medium text-foreground">
              {slot?.label}
            </div>
            {!slot?.available && (
              <div className="text-xs text-muted-foreground">Unavailable</div>
            )}
          </div>
        </button>
      ))}
    </div>
  );
};

export default TimeSlotSelector;